import { MenuItem } from './menu.model';
import { environment } from '../../../environments/environment';

export const MENU: MenuItem[] = [
    {
        id: 1,
        label: 'MENU',
        isTitle: true,
        showToSupportStaff: true
    },
    {
        id: 2,
        label: 'Dashboard',
        icon: 'bx-home-circle',
        link: '/dashboard'
    },
    {
        id: 158,
        label: 'Create Campaign',
        icon: 'bx-send',
        link: '/create-campaign',
        // Loads Planning Center service types and registration categories on
        // init with the signed-in user's own token, and exists to send real
        // messages to a real congregation. Both reasons to keep it out of a
        // support session.
        hideInSupportMode: true
    },
    {
        id: 149,
        label: 'Campaign Templates',
        icon: 'bxl-whatsapp',
        link: '/campaign-templates'
    },
    {
        id: 162,
        label: 'Manual Imports',
        icon: 'bx-import',
        link: '/manual-imports'
    },
    // {
    //     id: 153,
    //     label: 'Analytics',
    //     icon: 'bx-line-chart',
    //     link: '/analytics'
    // },
    {
        id: 154,
        label: 'History',
        icon: 'bx-history',
        link: '/history'
    },
    {
        id: 155,
        label: 'Scheduled',
        icon: 'bx-calendar-check',
        link: '/schedule'
    },
    {
        id: 156,
        label: 'Automations',
        icon: 'bx-bot',
        link: '/automations',
        // Planning Center triggers need PCO, but the contact-list triggers do
        // not, and the page shows only what the org can use — so while
        // workflows are switched on it is open to every organisation. With
        // them off only the PCO triggers remain, and so does the PCO gate.
        // Hidden from support sessions, which hold no Planning Center token
        // of their own.
        requiresPco: !environment.workflowsEnabled,
        hideInSupportMode: true
    },
    // Conversation workflows and contact-list automations. Unlike the
    // Automations page above, none of this needs Planning Center.
    ...(environment.workflowsEnabled ? [{
        id: 170,
        label: 'Workflows',
        icon: 'bx-git-branch',
        link: '/workflows'
    }] : []),
    {
        id: 157,
        label: 'Conversations',
        icon: 'bx-message-dots',
        link: 'conversations',
        showToSupportStaff: true
    },
    {
        id: 150,
        label: 'Organization',
        icon: 'bx-buildings',
        subItems: [
            {
                id: 151,
                label: 'Settings',
                link: '/organization/settings',
                parentId: 150
            },
            {
                id: 154,
                label: 'Users',
                link: '/organization/users',
                parentId: 150
            },
            {
                id: 152,
                label: 'Subscription',
                link: '/organization/subscription',
                parentId: 150,
                // Changing a customer's plan bills them. Not something to do
                // by accident while looking into a support ticket.
                hideInSupportMode: true
            },
            {
                id: 159,
                label: 'Messaging Pricing',
                link: '/organization/pricing',
                parentId: 150
            },
            {
                id: 153,
                label: 'Invoices',
                link: '/organization/invoices',
                parentId: 150,
                hideInSupportMode: true
            },
            {
                id: 160,
                label: 'AI Settings',
                link: '/ai-settings',
                parentId: 150,
                badge: { variant: 'warning', text: 'BETA' }
            },
            {
                id: 162,
                label: 'Message Filters',
                link: '/message-filters',
                parentId: 150
            },
            {
                id: 161,
                label: 'API Access',
                link: '/organization/api',
                parentId: 150
            },
            {
                id: 163,
                label: 'Website Chat',
                link: '/organization/widgets',
                parentId: 150
            },
            {
                id: 164,
                label: 'SMS',
                link: '/organization/sms',
                parentId: 150
            }
        ]
    }
];

